import { useBreadcrumb } from "features/breadcrumbs";
import { Flex } from "@chakra-ui/layout";
import Heading from "components/text/heading";
import { Col, Row } from "antd";
import { useLocation, useRouteMatch } from "react-router";
import CardDefault from "components/Cards/CardDefault";
import useSaveParceiro from "features/parceiros/hooks/useSaveParceiro";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import history from "infra/helpers/history";
import MenuDetalhes from "components/Menu/MenuDetalhes";
import { TabsDetalheParceiros, TabsDetalheParceirosRoutes } from "./typings";
import { useState } from "react";
import DadosDoParceiro from "./components/DadosDoParceiro";
import HorarioDeFuncionamento from "./components/HorarioDeFuncionamento";
import Fotos from "./components/Fotos";
import Endereco from "./components/Endereco";
import useParceiros from "features/parceiros/hooks/useParceiro";
import { useLoading } from "components/GlobalLoading";
import Container from "components/Container";

function ParceirosDetalhesPage() {
  const route = useRouteMatch<{ id: string }>();

  const { data, isLoading, isFetching } = useParceiros(route.params.id);
  const { mutate: handleSave, isLoading: isLoadingSave } = useSaveParceiro(
    route.params.id
  );
  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const opcaoParam = !route.params.id
    ? TabsDetalheParceirosRoutes.DadosDoParceiro
    : (params.get("opcao") as string) ||
      TabsDetalheParceirosRoutes.DadosDoParceiro;

  const [selectedMenuOption, setSelectedMenuOption] = useState(opcaoParam);

  const handleChangeMenu = (tab: string) => {
    setSelectedMenuOption(tab);

    if (route.params.id) {
      history.push(`/administracao/parceiros/${route.params.id}?opcao=${tab}`);
    } else {
      history.push(`/administracao/parceiros/criar?opcao=${tab}`);
    }
  };

  useBreadcrumb([
    { name: "Parceiros", url: "/administracao/parceiros" },
    {
      name: route.params.id
        ? data?.nome || "Editar parceiro"
        : "Cadastrar parceiro",
    },
  ]);

  useLoading(isLoading || isFetching);

  return (
    <Container pb={4}>
      <Flex mb="16px">
        <Heading>{data?.nome || "Cadastro de Parceiros"}</Heading>
      </Flex>

      <Row gutter={16}>
        <Col sm={5}>
          <MenuDetalhes<TabsDetalheParceirosRoutes>
            disabledOptions={
              !route.params.id
                ? [
                    TabsDetalheParceirosRoutes.HorarioDeFuncionamento,
                    TabsDetalheParceirosRoutes.Fotos,
                    TabsDetalheParceirosRoutes.Endereco,
                  ]
                : []
            }
            options={TabsDetalheParceiros}
            selectedOption={selectedMenuOption as TabsDetalheParceirosRoutes}
            onChangeOption={(tab) => {
              handleChangeMenu(tab);
            }}
          />
        </Col>

        <Col sm={19}>
          <CardDefault>
            {selectedMenuOption ===
            TabsDetalheParceirosRoutes.DadosDoParceiro ? (
              <DadosDoParceiro
                idParceiro={route.params.id}
                isLoading={isLoadingSave || isLoading}
                onSubmit={(v) =>
                  handleSave(v, {
                    onError: (e: any) => {
                      showErrorAxios(e);
                    },
                    onSuccess: ({ id }) => {
                      showSuccess().then(() => {
                        if (route.params.id) {
                          history.push(`/administracao/parceiros/${id}`);
                        } else {
                          history.push(
                            `/administracao/parceiros/${id}?opcao=${TabsDetalheParceirosRoutes.HorarioDeFuncionamento}`
                          );
                        }
                      });
                    },
                  })
                }
                value={data}
              />
            ) : null}

            {selectedMenuOption ===
              TabsDetalheParceirosRoutes.HorarioDeFuncionamento &&
            route.params.id ? (
              <HorarioDeFuncionamento idParceiro={route.params.id} />
            ) : null}

            {selectedMenuOption === TabsDetalheParceirosRoutes.Fotos &&
            route.params.id ? (
              <Fotos idParceiro={route.params.id} />
            ) : null}

            {selectedMenuOption === TabsDetalheParceirosRoutes.Endereco &&
            route.params.id ? (
              <Endereco idParceiro={route.params.id} />
            ) : null}
          </CardDefault>
        </Col>
      </Row>
    </Container>
  );
}

export default ParceirosDetalhesPage;
